// UI/display-only Rupiah input: live Indonesian thousand separators (".").
// Parent state stores the RAW integer digit string (e.g. "100000"); this component only formats
// the visible text. onChange emits raw digits, so existing amount validations/submits are unchanged.
export function RupiahInput({ value, onChange, ...props }) {
  const digits = String(value ?? "").replace(/\D/g, "");
  const display = digits ? digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "";
  return (
    <input
      {...props}
      type="text"
      inputMode="numeric"
      value={display}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
    />
  );
}
